var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "credit-card_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.21 10v10.421h55.58v-10.42zm0 19.684h55.58V54H4.21zm34.737 16.21h9.264v-4.63h-9.264z",
    clipRule: "evenodd"
  })));
};
export { SvgCreditCard as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQuMjEwNjMgMTAuMDAwMVYyMC40MjExSDU5Ljc4OTRWMTAuMDAwMUg0LjIxMDYzWk00LjIxMDYzIDI5LjY4NDNINTkuNzg5NFY1NEg0LjIxMDYzVjI5LjY4NDNaTTM4Ljk0NzMgNDUuODk0N0g0OC4yMTA1VjQxLjI2MzJIMzguOTQ3M1Y0NS44OTQ3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";